// Entrypoint-file for JS-Bundling

import './jqGlobal';
import './popperGlobal';

import $ from 'jquery';
import 'popper.js';
import 'bootstrap-material-design/js/index';
import 'bootstrap-select';
import bsCustomFileInput from 'bs-custom-file-input';

$(document).ready(function(){
    $('body').bootstrapMaterialDesign();
    bsCustomFileInput.init();
    console !== undefined && console.log('App ready');
});

// @see https://apaleo.dev/guides/start/apaleo-one/client-details#navigation
// TODO: configure id?
globalThis.gotoAccountConfig = function()  {
    window.parent.postMessage(JSON.stringify({
        type: 'navigate',
        path: 'apps',
        context: '$ACCOUNT',
        id: 'DETCOCONNECT-EXPEDIA_ACCOUNT_CONFIG'
    }), '*')
};
globalThis.gotoPropertyConfig = function(propertyId) {
    window.parent.postMessage(JSON.stringify({
        type: 'navigate',
        path: 'apps',
        context: propertyId ? propertyId : '$CURRENT_PROPERTY',
        id: 'DETCOCONNECT-EXPEDIA_PROPERTY_CONFIG'
    }), '*')
}
if (!String.format) {
    String.format = function (format) {
        var args = Array.prototype.slice.call(arguments, 1);
        return format.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    };
}
